import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import ReviewList from '../../components/admincomponents/ReviewList';

function AdminReviews({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ReviewList  />            
    </>
  );
}

export default AdminReviews;
